module.exports = __webpack_public_path__ + "static/img/tc03.94cd1e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc03.png
// module id = 172
// module chunks = 0